"use client";

import { Footer } from "@faire/retailer-visitor-shared/components/Footer/index";
import { useTraceComponentRender } from "@faire/web/common/tracing/useTraceComponentRender";
import * as React from "react";

interface IProps {
  className?: string;
  hideReferral?: boolean;
  noTopBorder?: boolean;
}

export const RetailerFooter: React.FC<IProps> = (props) => {
  useTraceComponentRender("RetailerFooter");

  return <Footer {...props} showRetailerFooter />;
};
